import { render, staticRenderFns } from "./editOrgDomain.vue?vue&type=template&id=d4e33470&"
import script from "./editOrgDomain.vue?vue&type=script&lang=tsx&"
export * from "./editOrgDomain.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports